import { defineMessages } from 'react-intl';

/**
 * IDs are content hashes of `defaultMessage` + `description`, auto-written by `formatjs/enforce-id` on
 * lint. The per-surface labels below deliberately keep the IDs and descriptions they were shipped or
 * translated under, so this menu's consolidation does not throw that work away — which is why their
 * descriptions still name the surface each label came from rather than this shared menu.
 */
export const inventoryConnectionMenuMessages = defineMessages({
  menuLabel: {
    defaultMessage: 'Actions for {connectionName}',
    id: '8c3bsg',
    description: 'Accessible label of the per-row actions menu on the inventory sync table',
  },
  targetOptionsMenuLabel: {
    defaultMessage: 'Target options for {connectionName}',
    id: 'igsw70',
    description: 'Accessible label for the overflow menu on an Inventory Sync target connection',
  },
  syncOptions: {
    defaultMessage: 'Sync Options',
    id: 'jJywO5',
    description: 'Button text for sync options dropdown item',
  },
  syncDetails: {
    defaultMessage: 'Sync Details',
    id: 'FTdYAl',
    description: 'Button text for sync details dropdown item',
  },
  syncHistory: {
    defaultMessage: 'Sync History',
    id: 'kgGUng',
    description: 'Menu item that opens the sync history for this product on the connection',
  },
});
